export const body = {
    // height: "100%"
};

export const mainMenuColumn = {
    width: "15%",
    height: "100%",
    float: "left"
};

export const mainContentBody = {
    // border: "1px solid black",
    width: "85%",
    float: "right",
    height: "100%"
};

export const roomsSection = {
    // border: "solid 1px black",
    borderRight: "solid 1px black",
    borderBottom: "solid 1px black",
    height: "60%"
};

export const itemsSection = {
    borderRight: "solid 1px black",
    height: "40%"
};

export const sectionTitle = {
    // height: "10%",
    // fontSize: "1.5rem",
    fontWeight: "bold",
    // borderRight: "1px solid black",

    display: "flex",
    flexDirection: "row",
    alignItems: "center"
};

export const sectionContent = {
    height: "100%"
    // backgroundColor: "white",
    // overflow: "scroll",
    // itemAlign: "right"
};

export const yourItems = {
    // backgroundColor: "white",
    borderRight: "solid 1px black",
    height: "40%"
};

export const navigationButtons = {
    textAlign: "center",
    backgroundColor: "rgba(108, 122, 137, 1)",
    color: "white",
    borderRadius: "25px",
    cursor: "pointer"
};
